import React from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { getConfidenceMeasureForPricePredictionV2 } from "../../api/api";
import { LoaderCentered } from "../../components/loaders/LoaderCentered";
import { useProperty } from "../../hooks/property.hooks";
import { SimilarityTable } from "../../components/tables/SimilarityTable";
import { ContentCard } from "../../components/ContentCard";
import { useTranslation } from "react-i18next";
import { PredictionsConfidenceMeasure } from "./PredictionsConfidenceMeasure";

interface ConfidenceV2RouteProps {}

export const ConfidenceV2Route: React.FC<ConfidenceV2RouteProps> = () => {
  const { t } = useTranslation();
  const { propertyId } = useParams();

  const { data, isLoading: isLoadingComparables } = useQuery(
    ["confidence_v2", propertyId],
    () => getConfidenceMeasureForPricePredictionV2(propertyId ?? "")
  );

  const { data: property, isLoading: isLoadingProperty } = useProperty(
    propertyId ?? ""
  );

  if (isLoadingComparables || isLoadingProperty) {
    return <LoaderCentered />;
  }

  if (!data || !property) {
    return <div>No data available</div>;
  }

  return (
    <div>
      <ContentCard title="Confidence">
        <PredictionsConfidenceMeasure confidence={data.confidence} />
      </ContentCard>
      <ContentCard title="Confidence V2 - Similarity Analysis">
        <SimilarityTable
          comparables={data.comparables}
          property={property}
          showStatus={false}
          enableGrouping={false}
        />
      </ContentCard>
    </div>
  );
};
